module.exports = __webpack_public_path__ + "fonts/Burukuduk-2.4757216d.otf";